/* eslint-disable react/jsx-no-undef */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo, useState, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import objectPath from "object-path";
import { toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from "../../../layout";
import { useDispatch, useSelector } from "react-redux";
import {
  getDashboardCount,
  getDashboardCampaignsRevenues,
  getDashboardCampaignTotalInvestment,
  getDashboardCampaignTotalRepayment,
  getDashboardTotalRevenueCount,
} from "../../../../store/actions/dashboard/dashboardActions";
import { useIsCrypto } from "../../../../helpers";
import { formatCurrency, toUsd } from "../../../../helpers/numberFormat";
import { CurrencyLogo } from "../../../../helpers/CryptoCurrencySymbol";
import { useGetPrice } from "../../../../swrHelpers/swrPriceConversionHelper";

export function StatsWidget1({ className, taxonomy }) {
  const uiService = useHtmlClassService();
  const dispatch = useDispatch();
  const [monthsRevenues, setMonthsRevenues] = useState([]);
  const [monthlyRevenuesTotal, setMonthlyRevenuesTotal] = useState([]);
  const { data: priceInUsd } = useGetPrice();

  const {
    dashboardCount,
    totalCampaignRevenues,
    totalCampaignInvestments,
    totalCampaignRePayment,
    dashboardSelectedCurrency,
    totalRevenueCount,
  } = useSelector((state) => state.dashboard);
  const { generalSettings } = useSelector((state) => state.settings);
  const { currentPermissions } = useSelector((state) => state.role);
  const layoutProps = useMemo(() => {
    return {
      colorsGrayGray500: objectPath.get(
        uiService.config,
        "js.colors.gray.gray500"
      ),
      colorsGrayGray200: objectPath.get(
        uiService.config,
        "js.colors.gray.gray200"
      ),
      colorsGrayGray300: objectPath.get(
        uiService.config,
        "js.colors.gray.gray300"
      ),
      colorsThemeBaseDanger: objectPath.get(
        uiService.config,
        "js.colors.theme.base.danger"
      ),
      colorsThemeBasePrimary: objectPath.get(
        uiService.config,
        "js.colors.theme.base.primary"
      ),
      fontFamily: objectPath.get(uiService.config, "js.fontFamily"),
    };
  }, [uiService]);

  useLayoutEffect(() => {
    dispatch(getDashboardCount());
    dispatch(getDashboardCampaignsRevenues(dashboardSelectedCurrency));
    dispatch(getDashboardCampaignTotalInvestment(dashboardSelectedCurrency));
    dispatch(getDashboardCampaignTotalRepayment(dashboardSelectedCurrency));
    dispatch(getDashboardTotalRevenueCount(dashboardSelectedCurrency));
  }, [dispatch, dashboardSelectedCurrency]);

  useLayoutEffect(() => {
    if (totalCampaignRevenues) {
      const monthsCampaignRevenues =
        totalCampaignRevenues?.revenueChartData?.map(function (item) {
          return item["_id"];
        });
      setMonthsRevenues(monthsCampaignRevenues);

      const campaignRevenuesTotal =
        totalCampaignRevenues?.revenueChartData?.map(function (item) {
          return item["totalEarnedFee"];
        });
      setMonthlyRevenuesTotal(campaignRevenuesTotal);
    }
  }, [totalCampaignRevenues, layoutProps]);

  const price = useMemo(() => {
    if (priceInUsd && totalCampaignInvestments?.currentCurrencyData?.symbol) {
      return priceInUsd[totalCampaignInvestments?.currentCurrencyData?.symbol];
    } else {
      return 0;
    }
  }, [priceInUsd, totalCampaignInvestments]);

  const isCryptoProject = useIsCrypto(
    totalCampaignInvestments?.currentCurrencyData?.symbol
  );

  return (
    <div className={`${className}`}>
      <div className="d-flex justify-content-between gap-3 gap-xl-5 flex-wrap flex-lg-nowrap">
        {currentPermissions?.view_active_projects_count && (
          <div className="w-100 ps-0">
            <div
              style={{ backgroundColor: "rgba(130, 128, 255, 0.1)" }}
              className="p-4 rounded-4">
              <div className="d-flex align-items-center justify-content-between gap-1">
                <Link
                  to="/campaign/campaigns"
                  className="text-black font-size-sm fw-medium text-decoration-none">
                  Active {taxonomy?.projectPlural}
                </Link>
                <span className="svg-icon svg-icon-3x d-block">
                  <SVG
                    src={toAbsoluteUrl(
                      "media/svg/icons/NewDashboard/active-project-icon.svg"
                    )}></SVG>
                </span>
              </div>
              <div className="text-black fw-bolder font-size-xl mt-2 lh-1">
                {dashboardCount.activeCampaign}
              </div>
            </div>
          </div>
        )}
        {currentPermissions?.view_new_users_count && (
          <div className="w-100 ps-0">
            <div
              style={{ backgroundColor: "rgba(254, 197, 61, 0.1)" }}
              className="p-4 rounded-4">
              <div className="d-flex align-items-center justify-content-between gap-1">
                <Link
                  to="/user-management/front-end-users"
                  className="text-black font-size-sm fw-medium text-decoration-none">
                  New Users
                </Link>
                <span className="svg-icon svg-icon-3x svg-icon-primary d-block">
                  <SVG
                    src={toAbsoluteUrl(
                      "media/svg/icons/NewDashboard/new-users-icon.svg"
                    )}></SVG>
                </span>
              </div>
              <div className="text-black fw-bolder font-size-xl mt-2 lh-1">
                {dashboardCount.newUsers}
              </div>
            </div>
          </div>
        )}
        {currentPermissions?.view_investment_count && (
          <div className="w-100 ps-0">
            <div
              style={{ backgroundColor: "rgba(74, 217, 145, 0.1)" }}
              className="p-4 rounded-4">
              <div className="d-flex align-items-center justify-content-between gap-1">
                <Link
                  to="/transaction"
                  className="text-black font-size-sm fw-medium text-decoration-none">
                  Investment
                </Link>
                <span className="svg-icon svg-icon-3x svg-icon-danger d-block">
                  <SVG
                    src={toAbsoluteUrl(
                      "media/svg/icons/NewDashboard/investment-icon.svg"
                    )}></SVG>
                </span>
              </div>
              <div className="text-black fw-bolder font-size-xl mt-2 lh-1 d-flex align-items-center">
                {isCryptoProject && (
                  <CurrencyLogo
                    symbol={
                      totalCampaignInvestments?.currentCurrencyData?.symbol
                    }
                    variant="dark"
                    className="mb-0"
                    height={18}
                  />
                )}
                <span className="mx-1">
                  {formatCurrency(
                    totalCampaignInvestments?.totalInvestment ?? 0,
                    generalSettings?.currencySymbolSide,
                    totalCampaignInvestments?.currentCurrencyData?.symbol ?? "",
                    "",
                    // totalCampaignInvestments?.currentCurrencyData?.code ?? "",
                    generalSettings?.decimalPoints
                  )}
                </span>

                {isCryptoProject ? (
                  <span className="conversion-usd-text">
                    (
                    {`$ ${toUsd(
                      Number(totalCampaignInvestments?.totalInvestment ?? "0"),
                      price
                    )}`}
                    )
                  </span>
                ) : null}
              </div>
            </div>
          </div>
        )}
        {currentPermissions?.view_repayment_count && (
          <div className="w-100 ps-0">
            <div
              style={{ backgroundColor: "rgba(255, 144, 102, 0.1)" }}
              className="p-4 rounded-4">
              <div className="d-flex align-items-center justify-content-between gap-1">
                <span className="text-black font-size-sm fw-medium">
                  Repayment
                </span>
                <SVG
                  src={toAbsoluteUrl(
                    "media/svg/icons/NewDashboard/repayment-icon.svg"
                  )}></SVG>
              </div>
              <div className="text-black fw-bolder font-size-xl mt-2 lh-1 d-flex align-items-center">
                {isCryptoProject && (
                  <CurrencyLogo
                    symbol={totalCampaignRePayment?.currentCurrencyData?.symbol}
                    variant="dark"
                    className="mb-0"
                    height={18}
                  />
                )}
                <span className="mx-1">
                  {formatCurrency(
                    totalCampaignRePayment?.totalRepayment ?? 0,
                    generalSettings?.currencySymbolSide,
                    totalCampaignRePayment?.currentCurrencyData?.symbol ?? "",
                    // totalCampaignRePayment?.currentCurrencyData?.code ?? "",
                    "",
                    generalSettings?.decimalPoints
                  )}
                </span>
                {isCryptoProject ? (
                  <span className="conversion-usd-text">
                    (
                    {`$ ${toUsd(
                      Number(totalCampaignRePayment?.totalRepayment ?? "0"),
                      price
                    )}`}
                    )
                  </span>
                ) : null}
              </div>
            </div>
          </div>
        )}

        {currentPermissions?.view_revenue_count &&
          generalSettings.paymentMethod !== "crypto-payment" && (
            <div className="w-100 ps-0">
              <div
                style={{ backgroundColor: "rgba(206, 94, 239, 0.1)" }}
                className="p-4 rounded-4">
                <div className="d-flex align-items-center justify-content-between gap-1">
                  <Link
                    to="/revenue-settings/transactions"
                    className="text-black font-size-sm fw-medium text-decoration-none">
                    Revenue
                  </Link>
                  <SVG
                    src={toAbsoluteUrl(
                      "media/svg/icons/NewDashboard/revenue-icon.svg"
                    )}></SVG>
                </div>
                <div className="text-black fw-bolder font-size-xl mt-2 lh-1">
                  {formatCurrency(
                    totalRevenueCount?.totalRevenue ?? 0,
                    generalSettings?.currencySymbolSide,
                    totalRevenueCount?.currentCurrencyData?.symbol ?? "",
                    // totalRevenueCount?.currentCurrencyData?.code ?? "",
                    "",
                    generalSettings?.decimalPoints
                  )}
                </div>
              </div>
            </div>
          )}
      </div>
    </div>
  );
}
